<div *ngIf="showModal" class="background">
    <!-- <forgottenPasswordModal *ngIf="template === 'forgottenPassword'" (closeModal)="close()"></forgottenPasswordModal>
    <loginModal *ngIf="template === 'login'" (closeModal)="close()"></loginModal>
    <signUpModal *ngIf="template === 'signUp'" (closeModal)="close()"></signUpModal> -->
</div>